import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
interface BuyButtonProps {
  className?: string;
  price?: boolean;
  final?: boolean;
}
export const BuyButton: React.FC<BuyButtonProps> = ({
  className = '',
  price = false,
  final = false
}) => {
  const handleClick = () => {
    if (final) {
      window.location.href = 'http://checkout.sectordigital.online/cart/44162409463851:1';
    } else {
      document.getElementById('purchase-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-29">
      {price && <div className="mb-3 text-center flex flex-col items-center" data-id="element-30">
          <span className="text-gray-500 line-through text-base" data-id="element-31">
            $49.990 ARS
          </span>
          <span className="text-navy font-bold text-3xl" data-id="element-32">$19.990 ARS</span>
        </div>}
      <motion.button onClick={handleClick} whileHover={{
      scale: 1.02,
      backgroundColor: '#16a34a'
    }} whileTap={{
      scale: 0.98
    }} className="bg-green-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg shadow-lg flex items-center justify-center gap-3 w-full max-w-md text-base sm:text-lg transition-colors" data-id="element-33">
        <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-34" />
        SÍ, QUIERO EL ACCESO AHORA
      </motion.button>
    </div>;
};